var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { codeStyle } from './styles';
function Code(_a) {
    var { as, inverted = false, size = 'inherit' } = _a, restProps = __rest(_a, ["as", "inverted", "size"]);
    const Element = as !== null && as !== void 0 ? as : 'code';
    return _jsx(Element, Object.assign({ css: codeStyle({ inverted, size }) }, restProps));
}
export default Code;
